import {Grid} from "@mui/material";
import React from "react";


interface TextFieldCounterProps {
    value: any,
    maxLength: number
}
export const TextFieldCounter: React.FC<TextFieldCounterProps> = ({value, maxLength}) => {
    return (
        <Grid item container justifyContent="flex-end">
            <Grid
                item
                xs="auto"
                style={{
                    paddingRight: '10px',
                }}
            >
                <label style={{color: '#8F90A6', fontSize: 10, fontFamily: "Mulish, sans-serif"}}>
                    {`${ value?.length ?? 0}/${maxLength}`}
                </label>
            </Grid>
        </Grid>
    )
}